import styled from 'styled-components';

interface Props {
  active: boolean;
}

export const Container = styled.section<Props>`
  background: white;
  box-shadow: ${({ theme }) => theme.searchInput.text.boxShadow};
  max-width: 100%;
  overflow: hidden;
  padding: 12px 16px;
  position: relative;
  border-radius: 8px;
  border: ${({ theme }) => theme.searchInput.text.border};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  border: 2px solid #b8b4b4;
`;

export const Content = styled.button`
  flex: 1;
  cursor: pointer;
  background: none;
  text-align: left;
  margin-right: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Name = styled.span<Props>`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 2px;
  color: ${({ theme, active }) =>
    active ? theme.searchInput.text.label.color : theme.searchInput.text.placeholder.label.color};
`;

export const Detail = styled.span<Props>`
  font-size: ${({ theme }) => theme.searchInput.text.detail.fontSize};
  overflow: hidden;
  line-height: 1.2em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme, active }) =>
    active ? theme.searchInput.text.detail.color : theme.searchInput.text.placeholder.detail.color};
`;
